const resources = {
    relatedContentLabel: 'Contenu relié',
    exploreMoreLabel: 'Découvrir plus'
};

module.exports = function getResource(label) {
    return resources[label];
};
